import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { CategoryOverview, CategoryOverviewCard } from '@cloudclevr/components';
import { UserRoles } from '@hooks/users/types';

export interface CategoriesListProps {
  categories: CategoryOverview[];
  userRole: 'Admin' | 'Platform' | 'Super-admin';
  onCategoryClick?: (categoryId: string) => void;
  customerId?: string;
  customerName?: string;
  className?: string;
}

const CategoriesList: React.FC<CategoriesListProps> = ({
  categories,
  userRole,
  onCategoryClick,
  customerId,
  customerName,
  className = ''
}) => {
  const navigate = useNavigate();
  const { roadmapId } = useParams<{ roadmapId: string }>();

  const handleCategoryClick = (categoryId: string) => {
    // If parent provided a callback, use it
    if (onCategoryClick) {
      onCategoryClick(categoryId);
      return;
    }

    // Otherwise, handle navigation here
    const category = categories.find(c => c.id === categoryId);
    if (category && roadmapId) {
      const targetPath = `/roadmaps/${roadmapId}/categories/${categoryId}/${category.name.replace(/\s+/g, '-').toLowerCase()}`;
      navigate(targetPath);
    }
  };

  return (
    <div className={`space-y-4 ${className}`} data-testid="categories-list">
      {categories.map((category) => (
        <CategoryOverviewCard
          key={category.id}
          category={category}
          userRole={UserRoles.ADMIN}
          onViewEdit={handleCategoryClick}
        />
      ))}
    </div>
  );
};

export default CategoriesList;